import { defineSagaForService } from '@repo/core'
import { getTaxProducts } from '@repo/user-services'
import { taxAddressRelatedProductsDataActions } from '../../slices'

export const taxAddressRelatedProductsServiceConfig = defineSagaForService({
  [taxAddressRelatedProductsDataActions.getRequest.type]: {
    apiClientDomain: 'user',
    service: getTaxProducts,
    actionTypeResponse: taxAddressRelatedProductsDataActions.getResponse.type,
    actionTypeRequest: taxAddressRelatedProductsDataActions.getRequest.type,
  },
  [taxAddressRelatedProductsDataActions.refreshRequest.type]: {
    apiClientDomain: 'user',
    service: getTaxProducts,
    actionTypeResponse: taxAddressRelatedProductsDataActions.refreshResponse.type,
    actionTypeRequest: taxAddressRelatedProductsDataActions.refreshRequest.type,
  },
})
